import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b66c622"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-reimburse-content"
};
const _hoisted_2 = {
  class: "order-info-content"
};
const _hoisted_3 = {
  class: "info-list"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "DBT订单号：", -1));
const _hoisted_5 = {
  class: "info-content"
};
const _hoisted_6 = {
  class: "info-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "三方订单号：", -1));
const _hoisted_8 = {
  class: "info-content"
};
const _hoisted_9 = {
  class: "info-list"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "内购ID：", -1));
const _hoisted_11 = {
  class: "info-content"
};
const _hoisted_12 = {
  class: "info-list"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "商品名称：", -1));
const _hoisted_14 = {
  class: "info-content"
};
const _hoisted_15 = {
  class: "info-list"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "价格：", -1));
const _hoisted_17 = {
  class: "info-content"
};
const _hoisted_18 = {
  class: "info-list"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "require"
}, "*"), /*#__PURE__*/_createTextVNode(" 退款金额： ")], -1));
const _hoisted_20 = {
  class: "info-list"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "require"
}, "*"), /*#__PURE__*/_createTextVNode(" 退款理由： ")], -1));
const _hoisted_22 = {
  class: "info-list"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "require"
}, "*"), /*#__PURE__*/_createTextVNode(" 客诉截图： ")], -1));
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-upload-text"
}, "点击上传", -1));
const _hoisted_26 = {
  class: "button-content"
};
const _hoisted_27 = {
  class: "left"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "只支持一年以内的订单退款", -1));
const _hoisted_29 = {
  key: 0,
  class: "right"
};
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
import { refundSubmit, retryRefundSubmit } from '@/api/orderApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDrawer',
  props: {
    modalVisible: {
      type: Boolean
    },
    orderInfo: null,
    isReadOnly: {
      type: Boolean
    }
  },
  emits: ['update:modalVisible', 'initRefund', 'updateList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const refundAmount = ref(0.01);
    const reasonForRefund = ref('');
    const fileList = ref([]);
    const loading = ref(false);
    const submitLoading = ref(false);
    const imageFile = ref();
    const handleCancel = () => {
      init();
      emit('update:modalVisible', false);
      emit('initRefund');
    };
    const uploadImage = async e => {
      var _props$orderInfo;
      if (loading.value) return;
      loading.value = true;
      // 判断是否是图片
      const isImage = e.file.type.includes('image');
      if (!isImage) {
        loading.value = false;
        return message.error('请上传图片');
      }
      imageFile.value = e.file;
      // 先上传图片
      const formData = new FormData();
      formData.append('file', imageFile.value);
      formData.append('businessId', (_props$orderInfo = props.orderInfo) === null || _props$orderInfo === void 0 ? void 0 : _props$orderInfo.orderNo);
      formData.append('businessType', 'ORDER_REFUND');
      formData.append('accessAttribute', '1');
      formData.append('desc', '');
      const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
      if (err) {
        fileList.value[fileList.value.length - 1].status = 'fail';
        loading.value = false;
        return message.error('上传图片失败');
      }
      if (res) {
        if (res.code === OK) {
          var _res$data;
          fileList.value[fileList.value.length - 1].url = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.fileUrl;
          fileList.value[fileList.value.length - 1].status = 'done';
          loading.value = false;
        }
      }
    };
    const submitRefund = async () => {
      var _props$orderInfo2, _fileList$value$map, _props$orderInfo3, _props$orderInfo5;
      if (!refundAmount.value) {
        return message.error('请输入退款金额');
      }
      if (Number(refundAmount.value) === 0) return message.error('退款金额不能为0');
      if (!reasonForRefund.value) {
        return message.error('请输入退款理由');
      }
      if (!fileList.value.length) {
        return message.error('请上传客诉截图');
      }
      submitLoading.value = true;
      let params = {
        orderNo: (_props$orderInfo2 = props.orderInfo) === null || _props$orderInfo2 === void 0 ? void 0 : _props$orderInfo2.orderNo,
        refundAmount: Number(refundAmount.value).toFixed(2),
        refundReason: reasonForRefund.value,
        customerComplaintUrl: (_fileList$value$map = fileList.value.map(item => item.url)) === null || _fileList$value$map === void 0 ? void 0 : _fileList$value$map.join(',')
      };
      if ((_props$orderInfo3 = props.orderInfo) !== null && _props$orderInfo3 !== void 0 && _props$orderInfo3.isEdit) {
        var _props$orderInfo4;
        params = {
          ...params,
          id: (_props$orderInfo4 = props.orderInfo) === null || _props$orderInfo4 === void 0 ? void 0 : _props$orderInfo4.id
        };
      }
      const fn = (_props$orderInfo5 = props.orderInfo) !== null && _props$orderInfo5 !== void 0 && _props$orderInfo5.isEdit ? retryRefundSubmit : refundSubmit;
      const [err, res] = await awaitWrap(fn(params));
      if (err) {
        submitLoading.value = false;
        return message.error('提交失败');
      }
      if (res) {
        if (res.code === OK) {
          submitLoading.value = false;
          message.success('提交成功');
          handleCancel();
          emit('updateList');
          Modal.confirm({
            title: '提示',
            centered: true,
            content: '退款申请已提交！可前往"飞书审批"查看审批进程'
          });
        } else {
          submitLoading.value = false;
        }
      }
    };
    const init = () => {
      refundAmount.value = 0.01;
      reasonForRefund.value = '';
      fileList.value = [];
      loading.value = false;
      submitLoading.value = false;
    };
    const refundAll = () => {
      var _props$orderInfo6, _props$orderInfo7;
      // 先判断是否是数字
      if (isNaN(Number((_props$orderInfo6 = props.orderInfo) === null || _props$orderInfo6 === void 0 ? void 0 : _props$orderInfo6.amount))) return message.error('金额格式错误');
      refundAmount.value = (_props$orderInfo7 = props.orderInfo) === null || _props$orderInfo7 === void 0 ? void 0 : _props$orderInfo7.amount;
      // 金额格式化
      refundAmount.value = Number(Number(refundAmount.value).toFixed(2));
    };
    watch(() => props.orderInfo, n => {
      if (n) {
        var _n$customerComplaintU;
        refundAmount.value = n.amount;
        refundAmount.value = n.refundAmount || 0.01;
        reasonForRefund.value = n.refundReason;
        fileList.value = ((_n$customerComplaintU = n.customerComplaintUrl) === null || _n$customerComplaintU === void 0 ? void 0 : _n$customerComplaintU.split(',').map(item => {
          return {
            uid: Math.random(),
            name: 'image.png',
            status: 'done',
            url: item
          };
        })) || [];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: __props.modalVisible,
        "root-class-name": "custom-order-class",
        placement: "right",
        title: "退款申请",
        width: "578px",
        onClose: handleCancel
      }, {
        default: _withCtx(() => {
          var _props$orderInfo8, _props$orderInfo9, _props$orderInfo10, _props$orderInfo11, _props$orderInfo12, _props$orderInfo13;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString((_props$orderInfo8 = __props.orderInfo) === null || _props$orderInfo8 === void 0 ? void 0 : _props$orderInfo8.orderNo), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString((_props$orderInfo9 = __props.orderInfo) === null || _props$orderInfo9 === void 0 ? void 0 : _props$orderInfo9.platOrderNo), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString((_props$orderInfo10 = __props.orderInfo) === null || _props$orderInfo10 === void 0 ? void 0 : _props$orderInfo10.prodId), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString((_props$orderInfo11 = __props.orderInfo) === null || _props$orderInfo11 === void 0 ? void 0 : _props$orderInfo11.prodName), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString((_props$orderInfo12 = __props.orderInfo) === null || _props$orderInfo12 === void 0 ? void 0 : _props$orderInfo12.amount), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_a_input_number, {
            disabled: __props.isReadOnly,
            value: refundAmount.value,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => refundAmount.value = $event),
            placeholder: "退款金额不可大于付款金额",
            min: 0.01,
            max: (_props$orderInfo13 = __props.orderInfo) === null || _props$orderInfo13 === void 0 ? void 0 : _props$orderInfo13.amount
          }, {
            addonAfter: _withCtx(() => {
              var _props$orderInfo14, _props$orderInfo15;
              return [_createTextVNode(_toDisplayString(((_props$orderInfo14 = __props.orderInfo) === null || _props$orderInfo14 === void 0 ? void 0 : _props$orderInfo14.currency) || ((_props$orderInfo15 = __props.orderInfo) === null || _props$orderInfo15 === void 0 ? void 0 : _props$orderInfo15.refundCurrency)), 1)];
            }),
            _: 1
          }, 8, ["disabled", "value", "min", "max"]), _createVNode(_component_a_button, {
            class: "refund-btn",
            type: "link",
            disabled: __props.isReadOnly,
            onClick: refundAll
          }, {
            default: _withCtx(() => [_createTextVNode("全额退款")]),
            _: 1
          }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_a_input, {
            disabled: __props.isReadOnly,
            value: reasonForRefund.value,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => reasonForRefund.value = $event),
            placeholder: "请输入"
          }, null, 8, ["disabled", "value"])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_a_upload, {
            "file-list": fileList.value,
            "onUpdate:file-list": _cache[2] || (_cache[2] = $event => fileList.value = $event),
            name: "avatar",
            "list-type": "picture-card",
            class: "avatar-uploader",
            action: "",
            "custom-request": uploadImage,
            disabled: loading.value || __props.isReadOnly
          }, {
            default: _withCtx(() => [fileList.value.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [loading.value ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0
            })) : (_openBlock(), _createBlock(_unref(PlusOutlined), {
              key: 1
            })), _hoisted_25])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["file-list", "disabled"])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_svg_icon, {
            "icon-class": "prompt",
            class: "prompt-icon"
          }), _hoisted_28]), !__props.isReadOnly ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_a_button, {
            onClick: handleCancel
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            class: "submit-btn",
            onClick: submitRefund,
            loading: submitLoading.value
          }, {
            default: _withCtx(() => [_createTextVNode("提交审批")]),
            _: 1
          }, 8, ["loading"])])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }, 8, ["open"]);
    };
  }
});